const AccessAlarmOutlined = () => {
  console.log('123131312');
};

export const initialStateforData = { finalPgaData: {} };
export function reducerForSaving(state, action) {
  switch (action.type) {
    case 'sshh':
      AccessAlarmOutlined();
      break;
    case 'unMount':
      console.log(
        'This note has been closed: ' + JSON.stringify(state.finalPgaData)
      ); // This note has been closed: 201
      break;
    case 'setFinalData':
      return { finalPgaData: action.payload };
    default:
      throw new Error();
  }
}
export const findNotMandatoryCondional = (NotMandatoryData, formData) => {
  let dataArray = extractData(formData);
  let nonManDatoryArray = extractNonManDatoryValues(NotMandatoryData);
  const finalArr = conditionalNonMandatory(dataArray, nonManDatoryArray);
  return finalArr;
};

export const extractData = (formData) => {
  let dataArray = [];
  for (const [key, value] of Object.entries(formData)) {
    if (value) {
      dataArray.push(key);
    }
  }
  return dataArray;
};

export const extractNonManDatoryValues = (NotMandatoryData) => {
  let nonManDatoryArray = [];
  if (NotMandatoryData && NotMandatoryData.length) {
    for (const element of NotMandatoryData) {
      if (element) {
        nonManDatoryArray.push(element.elementName);
      }
    }
  }
  return nonManDatoryArray;
};

export const conditionalNonMandatory = (dataArray, nonManDatoryArray) => {
  let newar = [];
  if (dataArray.length) {
    for (let i = 0; i < nonManDatoryArray.length; i++) {
      if (dataArray.includes(nonManDatoryArray[i])) {
      } else {
        newar.push(nonManDatoryArray[i]);
      }
    }
    return newar;
  } else {
    if (nonManDatoryArray.length) {
      return nonManDatoryArray;
    }
    return [];
  }
};

export const convertStringtoArrayOfObject = (value) => {
  var json = value;
  if (json) {
    var newJson = json.replace(/([a-zA-Z0-9]+?):/g, '"$1":');
    newJson = newJson.replace(/'/g, '"');

    var data = JSON.parse(newJson);
    return data;
  }
};
function insert(str, index, value) {
  return str.substr(0, index) + value + str.substr(index);
}
export const convertDate = (val) => {
  if (val) {
    let value = val;
    let str1 = insert(value, 4, '-');
    let str2 = insert(str1, 7, '-');
    return str2;
  }
  return null;
};
export const pgaAutomatedStatus = (currentPgaData) => {
  let newArr =
    currentPgaData && currentPgaData.length
      ? currentPgaData.map((item) => item.cbsaPgaType)
      : [];
  if (newArr.includes('HC') || newArr.includes('GAC') || newArr.includes('DFO')) {
    return true;
  }
  return false;
};
export const getNameOfSelectedPGAMemoized = (currentPgaData) => {
  let newArr = [];
  currentPgaData &&
    currentPgaData.length &&
    currentPgaData.map((item) => {
      if (item.pgaType == 'HC' || item.pgaType == 'GAC') {
        newArr.push(item.pgaType + '-' + item.programType);
      }
    });

  return newArr;
};
